import { z } from "zod";
import { sessionStore } from "../../lib/store";

/**
 * Marks the current tab as an automated screenshot session (entered via
 * `/screenshot-auth`). Room-entry interstitials — the HCP-identifier gate, the
 * "download the app" prompt — must NOT render in this mode: they cover the page
 * and, worse, their dismiss/cancel actions navigate away from the room (the HCP
 * gate's Cancel does `history.replace("/discovery")`), so an unattended capture
 * lands on the wrong page. Suppressing them lets the screenshot pipeline grab
 * the room content verbatim.
 *
 * Backed by sessionStorage so it survives the in-app redirect from the auth
 * bridge to the target route but never leaks to real users (each headless
 * capture runs in a fresh browser context, and real users never reach
 * `/screenshot-auth`).
 */
const screenshotSessionStore = sessionStore(
  "screenshot-session",
  false,
  z.boolean()
);

export function markScreenshotSession(): void {
  screenshotSessionStore.set(true);
}

export function isScreenshotSession(): boolean {
  return screenshotSessionStore.get();
}
